
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Activitiesresortnearnagpur() {



  const cardData =
  {
    keyword: ' Activities Resort Near Nagpur',
    heading:  'Woodland Escape: Activities Resort Near Nagpur',
    headingDescription: 'Woodland Escape Resort, a top-rated activities resort near Nagpur, offers the perfect mix of adventure, relaxation, and nature for guests seeking an engaging getaway close to the city. Surrounded by lush greenery and tranquil forest views, the resort features a wide range of recreational activities including ziplining, trekking, archery, cycling, nature walks, and team games that cater to both thrill-seekers and leisure lovers. Along with adventure zones, scenic lawns, and a refreshing swimming pool, guests can unwind with delicious meals and cozy cottage stays designed for ultimate comfort. Whether you’re planning a family outing, corporate event, or weekend retreat, Woodland Escape Resort near Nagpur ensures a fun-filled, activity-packed experience that blends excitement with natural serenity.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "Activities Resort Near Nagpur",
      "description": "Woodland Escape Resort is a top-rated activities resort near Nagpur, offering a perfect blend of recreation, adventure, and relaxation. The resort features a wide range of engaging activities including outdoor games, obstacle courses, nature walks, and team-building exercises. Whether you visit with family, friends, or colleagues, you’ll find something for everyone to enjoy in its scenic and peaceful environment."
    },
    {
      "name": "Nagpur Activity Center",
      "description": "Woodland Escape Resort serves as a vibrant activity center near Nagpur, designed for guests who love fun-filled experiences in the heart of nature. With dedicated play zones, adventure activities, and guided outdoor experiences, it caters to children, adults, and groups alike. The resort combines physical engagement with relaxation, making it a popular choice for educational trips and family outings."
    },
    {
      "name": "Nagpur Outdoor Activity Resort",
      "description": "For those seeking outdoor fun, Woodland Escape Resort is the ultimate outdoor activity resort near Nagpur. Guests can enjoy sports like volleyball, badminton, and cycling, as well as adventure activities like ziplining and rope challenges. The expansive green spaces and fresh air provide the ideal setting for reconnecting with nature while staying active."
    },
    {
      "name": "Nagpur Family Activity Spot",
      "description": "Woodland Escape Resort is a family-friendly activity spot near Nagpur where everyone can participate in outdoor fun. Families can enjoy games, nature trails, farm experiences, and picnic setups that bring everyone closer together. It’s an ideal destination for bonding, relaxation, and laughter amidst nature’s calm surroundings."
    },
    {
      "name": "Affordable Activity Resort Nagpur",
      "description": "Looking for an affordable activity resort near Nagpur? Woodland Escape Resort offers exciting activity packages that combine fun, adventure, and comfort at a reasonable price. Guests can enjoy a day packed with games, meals, and nature experiences without overspending. It’s a great option for budget-conscious families and groups."
    },
    {
      "name": "Nagpur Kids Activity Center",
      "description": "Woodland Escape Resort features a delightful kids’ activity center near Nagpur, offering a safe and engaging environment for children to play and learn. Activities include mini obstacle courses, nature exploration, animal interactions, and creative games that keep kids entertained. Parents can relax while their children enjoy outdoor fun under supervision."
    },
    {
      "name": "Nagpur Weekend Activity Trip",
      "description": "Plan your Nagpur weekend activity trip to Woodland Escape Resort for a refreshing and exciting experience. Spend your weekend enjoying outdoor sports, adventure challenges, and family games, all within a short drive from the city. The resort’s peaceful setting and variety of activities make it perfect for recharging after a busy week."
    },
    {
      "name": "Nagpur Fun Resort",
      "description": "Woodland Escape Resort is the ultimate fun resort near Nagpur, designed to entertain guests of all ages. With outdoor games, nature walks, adventure zones, and delicious food, it provides the ideal environment for enjoyment and relaxation. Whether it’s a one-day trip or a weekend outing, every visitor leaves with happy memories."
    },
    {
      "name": "Nagpur Adventure & Activity Spot",
      "description": "For those seeking both excitement and recreation, Woodland Escape Resort is the leading adventure and activity spot near Nagpur. Guests can indulge in thrilling activities like ziplining, archery, and climbing walls, alongside relaxing nature experiences. The resort’s natural setting ensures an unforgettable adventure blended with comfort."
    },
    {
      "name": "Nagpur Resort With Activities",
      "description": "Woodland Escape Resort is one of the few resorts near Nagpur that offers a comprehensive range of activities. From family games to adventure challenges, guests can customize their experience based on their interests. The resort’s spacious grounds, friendly staff, and scenic environment make it a complete destination for entertainment and relaxation."
    },
    {
      "name": "Nagpur Sports Activity Resort",
      "description": "Sports lovers will find Woodland Escape Resort an ideal sports activity resort near Nagpur. With open fields and equipment for football, cricket, volleyball, and badminton, it’s a hub for energetic fun. Guests can also take part in friendly competitions or simply enjoy the thrill of playing outdoors in nature’s lap."
    },
    {
      "name": "Nagpur Day Trip Activity Resort",
      "description": "For a one-day activity trip near Nagpur, Woodland Escape Resort offers a perfect itinerary filled with excitement. Guests can spend the day participating in various outdoor games, team-building exercises, and adventure sports, followed by delicious meals. It’s a great way to relax, have fun, and rejuvenate — all in a single day."
    },
    {
      "name": "Nagpur Group Activity Resort",
      "description": "Woodland Escape Resort is a popular group activity resort near Nagpur, ideal for corporate teams, schools, and friend groups. The resort organizes engaging group games, adventure tasks, and outdoor challenges that promote bonding and teamwork. Spacious lawns and well-maintained facilities make it suitable for large gatherings and events."
    },
    {
      "name": "Nagpur Resort Booking for Activities",
      "description": "Booking your activity day at Woodland Escape Resort near Nagpur is simple and flexible. The resort offers customized activity packages for families, groups, and corporates. Guests can choose from adventure sports, nature activities, and fun games to build their ideal day-out plan with meals and refreshments included."
    },
    {
      "name": "Nagpur Activity Packages",
      "description": "Woodland Escape Resort offers diverse activity packages near Nagpur that combine fun, food, and adventure. Each package includes access to multiple activities, scenic spots, and relaxation areas, ensuring a complete experience for every visitor. Whether you want a short trip or a full-day outing, the resort has a perfect package waiting for you."
    }
  ],
  "tableData": [
    ["- Activities Resort Near Nagpur", "- Nagpur Activity Center"],
    ["- Nagpur Outdoor Activity Resort", "- Nagpur Family Activity Spot"],
    ["- Affordable Activity Resort Nagpur", "- Nagpur Kids Activity Center"],
    ["- Nagpur Weekend Activity Trip", "- Nagpur Fun Resort"],
    ["- Nagpur Adventure & Activity Spot", "- Nagpur Resort With Activities"],
    ["- Nagpur Sports Activity Resort", "- Nagpur Day Trip Activity Resort"],
    ["- Nagpur Group Activity Resort", "- Nagpur Resort Booking for Activities"],
    ["- Nagpur Activity Packages", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Exciting Activities Resort Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is one of the top activity-based resorts near Nagpur, offering a perfect mix of adventure, fun, and nature. Set amidst dense forests, the resort provides a variety of engaging outdoor and indoor activities that make every visit unforgettable — whether you’re coming with friends, family, or colleagues."
  },
  {
    "WhyChooseheading": "Adventure Activities for All Ages",
    "WhyChoosedescription": "From thrilling zip-lines and rope courses to trekking, cycling, and archery, Woodland Escape Resort has adventure options for everyone. Designed with safety and excitement in mind, these activities allow you to experience the forest in a fun, energizing way while enjoying the natural surroundings."
  },
  {
    "WhyChooseheading": "Nature and Relaxation Experiences",
    "WhyChoosedescription": "For those who prefer a slower pace, the resort offers relaxing forest walks, bird watching, pondside lounging, and scenic photography spots. You can immerse yourself in the sounds and sights of nature while taking a refreshing break from daily life."
  },
  {
    "WhyChooseheading": "Perfect for Group Outings and Family Fun",
    "WhyChoosedescription": "Whether you’re planning a family picnic, a school trip, or a corporate outing, Woodland Escape Resort provides a perfect blend of activities and relaxation. Our wide open spaces, safe adventure setups, and forest-themed ambiance make it an ideal choice for group experiences filled with joy and bonding."
  },
  {
    "WhyChooseheading": "Fun Indoor and Outdoor Games",
    "WhyChoosedescription": "Beyond adventure activities, guests can enjoy a variety of fun games like badminton, volleyball, cricket, and carrom. There’s always something to keep everyone entertained, no matter the age or interest — making it a complete recreational experience near Nagpur."
  },
  {
    "WhyChooseheading": "Delicious Food to Fuel Your Adventure",
    "WhyChoosedescription": "A day full of activities deserves great food! Enjoy tasty, freshly prepared meals made from locally sourced ingredients. Our kitchen serves a mix of regional dishes and energizing snacks that keep you active and satisfied throughout your visit."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located just a short, scenic drive from Nagpur, Woodland Escape Resort is easy to reach for a quick day of fun and adventure. Its convenient location makes it the perfect choice for those seeking a nearby getaway filled with exciting activities and refreshing natural beauty."
  }
]







  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort popular as an activities resort near Nagpur?",
    answer: "Woodland Escape Resort is known for its exciting range of outdoor and indoor activities designed for families, friends, and corporate groups. Surrounded by beautiful nature, it’s the perfect place to enjoy adventure, relaxation, and recreation all in one destination."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is located around 45 km from Nagpur, just a 1 to 1.5-hour drive away. Its convenient location makes it an ideal getaway for adventure lovers and nature enthusiasts looking for an activity-filled experience close to the city."
  },
  {
    question: "What types of activities can guests enjoy at Woodland Escape Resort?",
    answer: "We offer a wide variety of activities including zip-lining, rope courses, archery, rock climbing, boating, cycling, nature walks, and outdoor games like volleyball and cricket. Indoor games and relaxation zones are also available for guests who prefer a laid-back experience."
  },
  {
    question: "Are there activities suitable for kids and families?",
    answer: "Yes! Woodland Escape Resort is a family-friendly destination with safe and engaging activities for kids and adults alike. From fun outdoor games to animal interactions and nature trails, there’s something for everyone to enjoy."
  },
  {
    question: "Do you offer group or corporate activity packages?",
    answer: "Absolutely! We specialize in hosting corporate outings, school trips, and group adventures. Our team can organize customized activity packages, including team-building exercises, adventure challenges, and group meals for an unforgettable day."
  },
  {
    question: "How can we book a visit to Woodland Escape Resort for activities?",
    answer: "Booking is simple — you can call or WhatsApp our reservations team or visit our official website to book your day. Advance booking is recommended to secure preferred time slots for specific activities and group packages."
  }
];

const testimonials = [
  {
    name: "Mr. Nikhil & Family, Nagpur",
    text: "We had an amazing time at Woodland Escape Resort! The range of activities was impressive — from zip-lining to boating, everything was well-organized and safe. A great spot for families looking for fun and adventure near Nagpur."
  },
  {
    name: "Miss. Shweta & Team, Nagpur",
    text: "Our corporate outing at Woodland Escape Resort was full of exciting activities and team games. The staff was very helpful, and the food was delicious. Highly recommended for anyone looking for an adventure-filled resort near Nagpur!"
  }
];






      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Activities Resort Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/activities-resort-near-nagpur.jpg",
  "description": "Discover endless fun at Woodlandescape Resort — the best activities resort near Nagpur. Enjoy outdoor games, adventure sports, family-friendly fun, and relaxation in a scenic nature-filled environment perfect for all ages.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1428"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/activities-resort-near-nagpur"
  }
};




  return (
    <div>
<Helmet>
  <title>Activities Resort Near Nagpur | Fun & Adventure Spot | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Spend an exciting day at Woodlandescape Resort — a popular activities resort near Nagpur. Perfect for families, kids, and groups with outdoor games, adventure activities, and weekend fun experiences." 
  />
  <meta 
    name="keywords" 
    content="Activities Resort Near Nagpur, Nagpur Activity Center, Nagpur Outdoor Activity Resort, Nagpur Family Activity Spot, Affordable Activity Resort Nagpur, Nagpur Kids Activity Center, Nagpur Weekend Activity Trip, Nagpur Fun Resort, Nagpur Adventure & Activity Spot, Nagpur Resort With Activities, Nagpur Sports Activity Resort, Nagpur Day Trip Activity Resort, Nagpur Group Activity Resort, Nagpur Resort Booking for Activities, Nagpur Activity Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Activitiesresortnearnagpur;